import { Box, TextField } from '@mui/material';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useProductQuantityInputStyles } from '../../../../../../../../../../../components/Product/useProductQuantityInputStyles';
import Typography from '../../../../../../../../../../../components/v2/ui/Typography/Typography';
import teceoInputConfig from '../../../../../../../../../../../utils/TeceoInputConfig';
import { usePackStyles } from '../../../../styles/usePackStyles';

type PacksMenuItemGridMultiplyDesktopProps = {
  readMode: boolean;
  showStock: boolean;
  packMultiplier?: number;
  willConsumeStock?: boolean;
  stockAvailableAmount?: number;
  isPackWithUnavailableStock: boolean;
  handleClickGridMultiply: () => void;
  handleInput: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const PacksMenuItemGridMultiplyDesktop = forwardRef<
  HTMLInputElement | undefined,
  PacksMenuItemGridMultiplyDesktopProps
>(
  (
    {
      readMode,
      showStock,
      handleInput,
      packMultiplier,
      stockAvailableAmount,
      handleClickGridMultiply,
      isPackWithUnavailableStock,
      willConsumeStock = false,
    },
    ref,
  ) => {
    const { classes: packStyles } = usePackStyles();

    const { classes: productInputStyles } = useProductQuantityInputStyles();

    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          columnGap: '2px',
          width: 68,
          position: 'relative',
        }}
      >
        <Typography color="textSecondary">x</Typography>
        <TextField
          {...teceoInputConfig}
          type="number"
          className={classNames(packStyles.multiplierTextField, productInputStyles.textField)}
          onClick={(e) => e.stopPropagation()}
          defaultValue={packMultiplier ?? ''}
          onFocus={(event: React.FocusEvent<HTMLInputElement>) => event.target.select()}
          inputRef={ref}
          onInput={handleInput}
          onChange={handleClickGridMultiply}
          disabled={readMode}
          slotProps={{
            input: {
              inputProps: {
                min: 0,
                max: stockAvailableAmount ?? 999,
              },
              type: 'number',
              className: packStyles.multiplierInput,
              error: isPackWithUnavailableStock,
            },
          }}
        />
        {showStock && willConsumeStock && (
          <Typography variant="body2" color="textSecondary" className={packStyles.stockQuantity}>
            {stockAvailableAmount}
          </Typography>
        )}
      </Box>
    );
  },
);

export default PacksMenuItemGridMultiplyDesktop;
